import React from "react"

export enum DeviceType {
  MOBILE_SMALL = "MOBILE_SMALL",
  MOBILE_LARGE = "MOBILE_LARGE",
  TABLET = "TABLET",
  DESKTOP = "DESKTOP",
}

export interface DevicePresetConfig {
  name: string
  width: string
  height: string
  icon: React.ReactNode
}

export const devicePresetConfigs: Record<DeviceType, DevicePresetConfig> = {
  [DeviceType.MOBILE_SMALL]: {
    name: "Mobile (Small)",
    width: "320px",
    height: "568px",
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path d="M8 16.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM5 4a2 2 0 012-2h6a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V4zm2-1a1 1 0 00-1 1v12a1 1 0 001 1h6a1 1 0 001-1V4a1 1 0 00-1-1H7z" />
      </svg>
    ),
  },
  [DeviceType.MOBILE_LARGE]: {
    name: "Mobile (Large)",
    width: "390px",
    height: "844px",
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path d="M7 2a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zm6 14H7V4h6v12z" />
      </svg>
    ),
  },
  [DeviceType.TABLET]: {
    name: "Tablet",
    width: "768px",
    height: "1024px",
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm8 14H6V4h8v12z" />
      </svg>
    ),
  },
  [DeviceType.DESKTOP]: {
    name: "Desktop",
    width: "100%",
    height: "100%",
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l2-8h8l2 8z" />
      </svg>
    ),
  },
}
